<div class="alert">
  <div class="alert__text" [innerHTML]="text"></div>

  <div class="alert__button"><brt-button color="river" title="Schließen" size="large" (click)="onClosed.emit(true)"></brt-button></div>
</div>
